const _excluded = ["size"];
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
      (o = n[r]),
        -1 === t.indexOf(o) &&
          {}.propertyIsEnumerable.call(e, o) &&
          (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  return t;
}
function _extends() {
  return (
    (_extends = Object.assign
      ? Object.assign.bind()
      : function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = arguments[e];
            for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }
          return n;
        }),
    _extends.apply(null, arguments)
  );
}
import React from "react";
var SumUpLogo24 = function SumUpLogo24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    _extends(
      {
        width: "82",
        height: "24",
        viewBox: "0 0 82 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
      props,
    ),
    /*#__PURE__*/ React.createElement("path", {
      d: "M22.171.19H1.943C1.029.19.267.952.267 1.867V21.98c0 .914.762 1.676 1.676 1.676H22.17c.915 0 1.677-.762 1.677-1.676V1.867c0-.953-.762-1.677-1.677-1.677ZM15.048 17.83c-2.057 2.057-5.334 2.133-7.505.266l-.038-.038a.356.356 0 0 1 0-.495l7.314-7.276a.4.4 0 0 1 .495 0c1.905 2.21 1.829 5.485-.266 7.543Zm1.523-11.62-7.314 7.277a.4.4 0 0 1-.495 0c-1.905-2.172-1.829-5.448.228-7.505 2.058-2.057 5.334-2.133 7.505-.267 0 0 .038 0 .038.038.19.115.19.343.038.458Z",
      fill: "currentColor",
      className: "logo-symbol",
    }),
    /*#__PURE__*/ React.createElement(
      "g",
      {
        className: "logo-text",
        fill: "currentColor",
      },
      /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M55.048 6.705h-.038a3.22 3.22 0 0 0-2.286.952 3.29 3.29 0 0 0-2.286-.952H50.4c-1.752 0-3.2 1.41-3.2 3.2v6.21c.038.495.419.876.914.876.495 0 .876-.381.915-.877v-6.21c0-.761.61-1.37 1.371-1.37h.038c.762 0 1.333.57 1.371 1.333v6.247c.047.45.364.877.877.877.495 0 .876-.381.914-.877V9.83c.038-.724.648-1.334 1.371-1.334h.039c.761 0 1.37.61 1.37 1.372v6.247c.039.495.42.877.915.877.495 0 .876-.381.914-.877v-6.21c.039-1.752-1.409-3.2-3.161-3.2Zm-10.82 0c-.495 0-.876.38-.914.876v6.21c0 .761-.61 1.37-1.41 1.37h-.037c-.762 0-1.41-.609-1.41-1.37V7.542c-.038-.495-.419-.876-.914-.876-.495 0-.876.38-.914.876v6.21c0 1.752 1.447 3.2 3.238 3.2h.038c1.79 0 3.238-1.448 3.238-3.2V7.58c0-.495-.42-.876-.915-.876Zm21.639 0c-.496 0-.877.38-.915.876v6.21c0 .761-.61 1.37-1.41 1.37h-.037c-.762 0-1.41-.609-1.41-1.37V7.542c-.038-.495-.419-.876-.914-.876-.495 0-.876.38-.914.876v6.21c0 1.752 1.447 3.2 3.238 3.2h.038c1.79 0 3.238-1.448 3.238-3.2V7.58c-.038-.495-.42-.876-.914-.876Z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d: "M71.924 6.705h-.038c-1.829 0-3.276 1.447-3.276 3.238v11.276c0 .495.418.914.914.914a.927.927 0 0 0 .914-.914v-4.686c.343.305.914.457 1.448.457h.038c1.828 0 3.2-1.561 3.2-3.352V9.867c0-1.79-1.372-3.162-3.2-3.162Zm1.447 7.01c0 .99-.647 1.409-1.41 1.409h-.037c-.8 0-1.41-.42-1.41-1.41V9.943c0-.762.648-1.41 1.41-1.41h.038c.8 0 1.41.61 1.41 1.41v3.771Z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.133 10.781c-1.028-.42-1.676-.686-1.676-1.295 0-.496.381-.953 1.257-.953.534 0 .99.229 1.334.686.228.267.457.42.723.42.534 0 .953-.42.953-.915 0-.19-.038-.381-.153-.495-.571-.877-1.752-1.486-2.857-1.486-1.523 0-3.085.952-3.085 2.78 0 1.867 1.523 2.477 2.78 2.934.991.381 1.867.724 1.867 1.524 0 .61-.571 1.219-1.638 1.219-.343 0-.952-.076-1.371-.571-.229-.267-.496-.381-.724-.381-.495 0-.953.419-.953.914 0 .19.077.38.19.533.572.876 1.868 1.296 2.858 1.296 1.676 0 3.505-1.067 3.505-3.01-.038-2.057-1.676-2.705-3.01-3.2Z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d: "M79.39 6.705a1.829 1.829 0 1 0 .001 3.658 1.829 1.829 0 0 0 0-3.658Zm0 3.2c-.761 0-1.371-.61-1.371-1.372 0-.762.61-1.371 1.371-1.371.762 0 1.372.61 1.372 1.371 0 .762-.61 1.372-1.371 1.372Z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d: "M79.581 8.61a.453.453 0 0 0 .38-.458c0-.304-.228-.495-.57-.495h-.458c-.114 0-.19.076-.19.19v1.258c0 .114.076.19.19.19.115 0 .19-.076.19-.19v-.457l.458.571c.038.076.076.076.19.076.153 0 .19-.114.19-.19s-.037-.115-.075-.153l-.305-.342Zm-.152-.267H79.2v-.381h.229c.114 0 .19.076.19.19 0 .077-.076.19-.19.19Z",
      }),
    ),
  );
};
const sizeMap = {
  24: SumUpLogo24,
};
export function SumUpLogo(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    console.warn(
      new Error(
        "The '".concat(
          size,
          "' size is not supported by the 'SumUpLogo' icon. Please use one of the available sizes: '24'.",
        ),
      ),
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
